import { PASSWORD_RULES } from '@seller/shared';

/**
 * Live checklist of the password policy.
 *
 * Driven by the same rule list the API enforces, so the boxes someone is
 * ticking cannot disagree with what the server will accept. Nothing is marked
 * failed until the field has been touched — showing four red crosses against an
 * empty box reads as an error the user has not made yet.
 */
export function PasswordChecklist({ password }: { password: string }) {
  const touched = password.length > 0;

  return (
    <ul className="mt-2 space-y-1">
      {PASSWORD_RULES.map((rule) => {
        const passed = rule.test(password);
        return (
          <li
            key={rule.id}
            className={`flex items-center gap-2 text-xs ${
              passed ? 'text-brand-700' : touched ? 'text-muted' : 'text-faint'
            }`}
          >
            <span aria-hidden className="w-3 text-center">
              {passed ? '✓' : '·'}
            </span>
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}

/** Whether every rule is satisfied, for gating a submit button. */
export function passwordMeetsPolicy(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}
